export default __webpack_public_path__ + "static/media/logo.fb7576df4f1fd2de77a519fcf3704681.svg";